import { fetchAddress, formatPayment } from "../../../../../lib/utils";
import { Card, CardHeader, CardContent, CardTitle } from "../../../../ui/card";
import { Clock, DollarSign, Calendar, MapPin, Navigation } from "lucide-react";
import { useState, useEffect } from "react";

export function JobInformation({ jobData }) {
  const [address, setAddress] = useState("");
  const [loadingAddress, setLoadingAddress] = useState(true);
  const [error, setError] = useState(null);

  const formatScheduledTime = () => {
    const { hour, minute, period } = jobData.scheduledTime;
    return `${hour}:${minute} ${period}`;
  };

  const formatScheduledDate = (timestamp) => {
    return new Date(timestamp).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  useEffect(() => {
    const fetchAddressData = async () => {
      if (!jobData?.location?.coordinates || jobData.location.coordinates.length !== 2) {
        setError("Invalid location data");
        setLoadingAddress(false);
        return;
      }

      try {
        setLoadingAddress(true);
        setError(null);
        
        // Extract coordinates - [0] is longitude, [1] is latitude
        const [longitude, latitude] = jobData.location.coordinates;
        const addressString = await fetchAddress(latitude, longitude);
        
        setAddress(addressString);
      } catch (err) {
        setError("Failed to fetch address");
        console.error("Error fetching address:", err);
      } finally {
        setLoadingAddress(false);
      }
    };

    fetchAddressData();
  }, [jobData?.location?.coordinates]);

  console.log(jobData);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="w-5 h-5" />
          Service Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Address Card - Always spans full width */}
        <div className="col-span-full">
          <div className="flex items-center gap-3 p-4 bg-gray-50">
            <Navigation className="w-5 h-5" />
            <div className="flex-1">
              <p className="text-sm text-gray-600 mb-1">Service Address</p>
              {loadingAddress ? (
                <div className="space-y-2">
                  <div className="h-4 bg-gray-300 rounded animate-pulse w-3/4"></div>
                </div>
              ) : error ? (
                <p className="text-red-600 font-medium">{error}</p>
              ) : (
                <p className="font-semibold text-gray-900">{address}</p>
              )}
            </div>
          </div>
        </div>

        {/* Other Info Items */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <InfoItem 
            icon={<Calendar className="w-5 h-5 text-blue-600" />}
            label="Service Date"
            value={formatScheduledDate(jobData.scheduledDate)}
          />
          <InfoItem 
            icon={<Clock className="w-5 h-5 text-purple-600" />}
            label="Service Time"
            value={formatScheduledTime()}
          />
          <InfoItem 
            icon={<DollarSign className="w-5 h-5 text-green-600" />}
            label="Amount"
            value={`$${formatPayment(jobData.paymentInfo.amount)}`}
          />
          <InfoItem 
            icon={<Clock className="w-5 h-5 text-orange-600" />}
            label="Service Duration"
            value={jobData.completionTime}
          />
        </div>
      </CardContent>
    </Card>
  );
}

function InfoItem({ icon, label, value }) {
  return (
    <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
      {icon}
      <div>
        <p className="text-sm text-gray-600">{label}</p>
        <p className="font-semibold">{value}</p>
      </div>
    </div>
  );
}